import {Nav} from 'Shared/frontend/icons/Nav';
import {NavMore} from 'Shared/frontend/nav/NavMore';
import {createSignal} from 'solid-js';
import {Show,For} from 'solid-js'
import { css, cx } from '@emotion/css';
import { fluidType } from 'Shared/common/FluidType';
import { theme, palette, sizes, useSettings } from 'Shared/frontend/SettingsProvider';
import { sanitise } from 'Shared/common/Sanitise';
import { Dynamic } from 'solid-js/web';
import { usePageDetails } from 'Shared/frontend/PageDetailsProvider';


const overlayStyle = () => css(theme().nav.mobile.overlay,{
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	height: '100vh',
	/* Should appear over other overlays: */
	zIndex: 50,
	margin: '0 auto',
	scrollbarWidth: 'none',
	overflow: 'auto',
	animationName: 'slideIn',
	animationDuration: '0.5s',
	backgroundColor: palette().background
});

const mobileStyle = () => css(theme().nav.mobile.backgroundWrap,{
	display: 'flex',
	
	flexWrap: 'nowrap',
	padding: 0,
	position: 'fixed',
	bottom: 0,
	left: 0,
	width: '100%',
	zIndex: 5,

//XXX Shared with StandardDefaultLayout etc
	maxWidth: 1380, /*was 1250 but wider displays 4 carousel items per row */
	marginLeft: 'auto',
	marginRight: 'auto',

	a: {
		flex: '1 1',
	}
});

const buttonStyle = () => css(theme().nav.mobile.button, {
//TODO use flex instead of this	
	width: '100%',
});

const activeStyle = () => css(theme().nav.mobile.active);

const buttonContentsStyle = () => css(theme().nav.mobile.button.contents,{
	display: 'block',
	margin: '0 auto',
	width: 'calc(30px + 20 * ((100vw - 375px ) / 225 ))',
	maxWidth: '90%',
});

const iconLabelStyle = () => css({
	fontSize: fluidType('px',sizes().endFontShrink,sizes().flipToMobileNav,10,16),
});

const closeIconStyle = () => css({
	...sanitise.button,
	position: 'fixed',
	top: 0,
	right: 0,
	padding: 20,
	color: 'inherit',
	backgroundColor: 'inherit',
	borderRadius: 0,
	fontSize: 40,
	fontWeight: 'bold'
});


export function MobileFooterNav(P)
{
	const mobile = useSettings().navContent().mobile;

	const maxButtons = () => mobile.includeMoreButton ? mobile.maxButtons - 1 : mobile.maxButtons;

	const [visible,setVisible] = createSignal(false);

	/* Warning: only supports a single overlay. Otherwise cf an 'overlayed' count. cf <Portal> */
	const openOverlay = () => {
		document.body.classList.add('overlayed');
		setVisible(true);

		/*
			Following a link to another page requires this BUT DOESNT WORK - as outside Solid tree.
				onCleanup(() => document.body.classList.remove('overlayed'));
			Relying on the router to cleanup 'overlayed'.
			MutationObserver might be better, but bit verbose.
		*/
	};

	const closeOverlay = () => {
		document.body.classList.remove('overlayed');
		setVisible(false);
	};


	return (<>
		<nav class={mobileStyle()}>
			<For each={mobile.links.slice(0,maxButtons())}>{item =>
				<a href={navItemLink(item)}>
					<button tabindex='-1' class={cx(buttonStyle(),isActive(item) && activeStyle())}>
						<div class={buttonContentsStyle(isActive(item))}>
							<Dynamic component={item.icon} />
						</div>
						<div class={iconLabelStyle()}>{item.label}</div>
					</button>
				</a>
			}</For>

			<Show when={mobile.includeMoreButton}>
				<a href=''>
					<button class={buttonStyle()} tabindex='-1' onClick={openOverlay}>
						<div class={buttonContentsStyle()}>
							<Nav />
						</div>
						<div class={iconLabelStyle()}>More</div>
					</button>
				</a>
			</Show>
		</nav>

		<Show when={visible()}>
			<div class={overlayStyle()}>
				<button class={closeIconStyle()} onClick={closeOverlay}>X</button>

				<NavMore {...P} closeOverlay={closeOverlay} />
			</div>
		</Show>
	</>);
}

export function navItemLink(item)
{
	if (item.page)
		return useSettings().pages().find(e => item.page==e.key)?.frontend?.route;
	else if (item.link)
		return useSettings().links()[item.link]?.target;
	else
		/* The 'More' button is a 3rd possibility */
		return '';
};

//TODO use in mobile too...
export function isActive(item)
{
	const page = item.page ?? item.link;

	if (usePageDetails().pageName?.startsWith('frontend/Custom')) 
		return `frontend/Custom/${page}` == usePageDetails().pageName;

	return page == usePageDetails().pageName;
}

